import { render, staticRenderFns } from "./common-icon.vue?vue&type=template&id=b5519250"
import script from "./common-icon.vue?vue&type=script&lang=ts"
export * from "./common-icon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports